module.exports = __webpack_public_path__ + "img/401.089007e7.gif";